import * as R from 'ramda';

export const hasLocalStorage = R.compose(
  R.is(Function),
  R.pathOr(null, ['localStorage', 'setItem']),
  R.defaultTo({})
)(window);
